<template>
  <div :class="`membership-card mb-4 ${print ? 'print' : ''}`" :style="style">
    <div v-if="orientation != 'portrait'" :class="orientation == 'responsive' ? 'd-none d-sm-block' : ''">
      <b-card>
        <b-row class="logo-picture">
          <b-col class="col-7">
            <div v-if="!!organization.logo" class="mb-2">
              <img :src="organization.logo" :height="print ? 60 : 40" />
            </div>
            <h5 v-if="!organization.logo">{{ organization.name }}</h5>
            <p>{{ membershipCard.membership_name }}</p>
            <p>
              {{ membershipCard.recipient_name }}
              <b-badge v-if="hasTowel" variant="secondary">{{ trans('towel') }}</b-badge>
            </p>
          </b-col>
          <b-col class="col-5 text-right">
            <img v-if="membershipCard.membership_has_photo && !!membershipCard.recipient_image_url" :src="membershipCard.recipient_image_url" class="d-inline-block border" :height="largePhoto ? 200 : (print ? 140 : 90)" />
            <div v-if="membershipCard.membership_has_photo && !membershipCard.recipient_image_url" :class="`d-inline-block display-${largePhoto || print ? 1 : 3} border ${print ? 'p-0' : 'p-2'} text-center`">
              <i class="fa fa-fw fa-user"></i>
            </div>
            <small v-if="(!print || printExp) && !!membershipCard.expired_at" :class="`d-block text-${isExpired ? 'danger' : 'muted'}`">
              Exp. {{ moment(membershipCard.expired_at).format('ll') }}
            </small>
          </b-col>
        </b-row>
        <b-row v-if="!membershipCard.status">
          <b-col class="text-center">
            <barcode
              :value="membershipCard.no"
              tag="svg"
              :options="barcodeOptions"
            ></barcode>
          </b-col>
        </b-row>
        <b-row v-if="!!status">
          <b-col class="text-center text-danger">
            <div>
              {{ status }}
            </div>
            <small v-if="!!statusAbout" class="d-block">{{ statusAbout }}</small>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div v-if="orientation != 'landscape'" :class="orientation == 'responsive' ? 'd-sm-none' : ''">
      <b-card class="text-center">
        <div v-if="!!organization.logo" class="mb-2">
          <img :src="organization.logo" height="30" />
        </div>
        <h5 v-if="!organization.logo">{{ organization.name }}</h5>
        <p>{{ membershipCard.membership_name }}</p>
        <b-row align-h="center" align-v="center">
          <b-col class="col-auto">
            <div v-if="membershipCard.membership_has_photo && !!membershipCard.recipient_image_url" class="text-center">
              <img :src="membershipCard.recipient_image_url" class="d-inline-block border" :height="largePhoto ? 200 : 90" />
            </div>
            <div v-if="membershipCard.membership_has_photo && !membershipCard.recipient_image_url" :class="`d-inline-block display-${largePhoto ? 1 : 3} border p-2 text-center`">
              <i class="fa fa-fw fa-user"></i>
            </div>
          </b-col>
          <b-col v-if="largePhoto && hasTowel" class="col-auto">
            <div class="display-4 text-muted">
              <i class="fa fa-fw fa-scroll"></i>
            </div>
          </b-col>
        </b-row>
        <p>
          {{ membershipCard.recipient_name }}
          <b-badge v-if="hasTowel" variant="secondary">{{ trans('towel') }}</b-badge>
        </p>
        <barcode
          v-if="!membershipCard.status"
          :value="membershipCard.no"
          tag="svg"
          :options="barcodeOptions"
        ></barcode>
        <small v-if="!!membershipCard.expired_at" :class="`d-block text-${isExpired ? 'danger' : 'muted'} mt-3`">
          Exp. {{ moment(membershipCard.expired_at).format('LL') }}
        </small>
        <div v-if="!!status" class="text-center text-danger">
          <div>
            {{ status }}
          </div>
          <small v-if="!!statusAbout" class="d-block">{{ statusAbout }}</small>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
  import Barcode from '@chenfengyuan/vue-barcode'

  export default {
    props: {
      organization: Object,
      membershipCard: Object,
      orientation: {
        type: String,
        default: 'responsive', // landscape (desktop/tablet/print), portrait (smartphone) or responsive
      },
      largePhoto: {
        type: Boolean,
        default: false,
      },
      print: {
        type: String,
        default: null, // Letter, CR80 or null (default)
      },
      printExp: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Barcode,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        numeral: numeral,
      }
    },
    computed: {
      style() {
        if (this.print == 'CR80') return 'max-width: 500px;'
        return null
      },
      barcodeOptions() {
        return {
          height: this.print ? 40 : 30,
          width: (this.membershipCard.no+'').length < 10 ? 2 : 1,
          fontSize: 14,
          text: this.membershipCard.text || this.membershipCard.no,
        }
      },
      isExpired() {
        if (!this.membershipCard || !this.membershipCard.expired_at) return null
        return moment().startOf('day').isAfter(this.membershipCard.expired_at)
      },
      status() {
        if (!this.membershipCard) return null
        if (this.membershipCard.status == 'pending') {
          return trans('membership_pending')
        }
        if (this.membershipCard.status == 'suspended') {
          return trans('suspended')
        }
        if (this.isExpired === true) {
          return trans('expired')
        }
        return null
      },
      statusAbout() {
        if (!this.membershipCard) return null
        if (['pending', 'suspended'].indexOf(this.membershipCard.status) >= 0) {
          return trans('membership_' + this.membershipCard.status + '_about')
        }
        return null
      },
      hasTowel() {
        if (!this.membershipCard || !this.membershipCard.note) return false
        return _.noteHasTowel(this.membershipCard.note)
      },
    },
  }
</script>